var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"finish",staticClass:"go active"},[_c('div',{staticClass:"circle-1"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"circle-2"}),_c('div',{staticClass:"circle-3"}),_c('div',{staticClass:"circle-4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }